import { MessageCircle, Phone } from "lucide-react";
import { InstallAppButton as SharedInstallButton } from "@/components/Download";
import { Button } from "@/components/ui/button";
import { SUPPORT_PHONE, SUPPORT_TEL, SUPPORT_WA } from "@/lib/api";

export const Logo = ({ className = "h-10 w-10" }) => (
  <img src="/logo-sm.png" alt="Gazi Sepet" className={`${className} object-contain`} data-testid="brand-logo" />
);

export const SupportButtons = ({ compact = false, prefix = "support" }) => (
  <div className={`flex ${compact ? "gap-2" : "flex-col sm:flex-row gap-3"}`}>
    <a href={SUPPORT_WA} target="_blank" rel="noreferrer" data-testid={`${prefix}-whatsapp-btn`}>
      <Button className="bg-[#25D366] hover:bg-[#1eb457] text-white rounded-full gap-2 w-full">
        <MessageCircle className="h-4 w-4" /> WhatsApp{compact ? "" : " ile Yaz"}
      </Button>
    </a>
    <a href={SUPPORT_TEL} data-testid={`${prefix}-call-btn`}>
      <Button variant="outline" className="rounded-full gap-2 w-full border-[#0F1F45]/20">
        <Phone className="h-4 w-4" /> {SUPPORT_PHONE}
      </Button>
    </a>
  </div>
);

// Kurye / Caller ID uygulamaları için aynı (global olarak yakalanan) kurulum düğmesi.
export function InstallAppButton({ testId = "install-app-btn", tone = "dark" }) {
  return <SharedInstallButton testId={testId} tone={tone} label="Telefona Yükle" />;
}
